import React, { useImperativeHandle } from 'react';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import { useLocation } from 'react-router';

const useStyles = makeStyles(theme => ({
  appMainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    padding: '50px 0px 0px 0px',
    [theme.breakpoints.down('md')]: {
      paddingTop: 60,
      paddingBottom: 20,
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 20,
      paddingBottom: 20,
    },
  },
  certificationContent: {
    paddingTop: 0,
    paddingBottom: 0,
    [theme.breakpoints.down('md')]: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
}));

const CmtContent = React.forwardRef(function LayoutContent(props, ref) {
  const { children } = props;

  useImperativeHandle(ref, () => ({}));

  const contentRef = React.createRef();
  const classes = useStyles();
  const location = useLocation();
  const isCertificationPage = location.pathname?.startsWith('/dealer/certification');
  const isSectionLandingPage = /^\/dealer\/section\/[^/]+\/landing\/?$/i.test(location.pathname || '');

  return (
    <Box
      ref={contentRef}
      className={clsx(classes.appMainContent, 'Cmt-appMainContent', {
        [classes.certificationContent]: isCertificationPage || isSectionLandingPage,
      })}
      bgcolor="background.main">
      {children}
    </Box>
  );
});

export default CmtContent;
CmtContent.defaultProps = {
  name: 'LayoutContent',
};
